import {NavLink, Route, RouteComponentProps, Switch, useHistory, withRouter} from "react-router-dom";
import React from "react";
import {connect} from "react-redux";
import {login, showLogin} from "../../user/UserActions";
import {Dispatch} from "redux";
import {AppState} from "../../RootReducer";
import {
    showSideMenu,
    toggleShowPoker,
    toggleShowSportsbook,
    toggleShowUserNavigation
} from "../../navigation/NavigationActions";
import {AccountBalance, AppMode, CasinoPage, ManualLoginRequest, MenuItem, MenuItemType, MenuPosition, Settings} from "../../http/protocol";

import {ContentModelName, GlobalPayload, PopupAppInstall} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import "./styles/NavMenu.scss";
import {fetchSettings} from "../../settings/SettingsActions";
import Loggedin from "../../layout/Loggedin";
import {t} from "../../i18n";
import LanguageMenu from "../language/LanguageMenu";
import {getContainer} from "../../ioc/IOCSetup";
import {isCasinoMenuItemActive, mapMenuItemData, MenuItemData} from "./MenuUtils";
import {BrandLogo} from "./NavMenu";
import {BrandA} from "../buttons/buttons";
import {getSelectedPage} from "../../selectors/casino-selectors";
import {SettingsService} from "../../settings/SettingsService";
import { PATH } from "../../onboardingpage/modalview/UserModalController";
import { setModalPath } from "../../onboardingpage/modalview/utils";
import "./styles/MenuLayout.scss";
import jsondata from "../../assets/custom-icons/custom/index.json"
interface State {
    mobile: boolean;
    animate: boolean;
    scrolled: boolean;
    smallScreen: boolean;
    pokerLoaded: boolean;
}

interface Props extends RouteComponentProps {
    showLogin? : ()=> void;
    loggedIn?: boolean;
    balances?: AccountBalance[];
    transparent?: boolean;
    showUserNavigation? : (show : boolean) => void;
    fetchContent: typeof fetchContent;
    fetchSettings: typeof fetchSettings;
    login: typeof login;
    global?: GlobalPayload;
    settings?: Settings;
    animate?: boolean;
    delay?: number;
    lng: string;
    popupAppInstall?: PopupAppInstall;
    appMode?: AppMode;
    sportsbookVisible:boolean;
    pokerVisible:boolean;
    toggleShowSportsbook? : typeof toggleShowSportsbook;
    toggleShowPoker? : typeof toggleShowPoker;
    selectedPage? : CasinoPage;
    showSideMenu? : (show : boolean) => void;
    isLandingPage? : boolean;
    pokerLoadingComplete? : boolean;
    userModal: any,
    userCountry? : string;
    ipCountry? : string;
    isSidemenuExpanded?: boolean;
    position?: MenuPosition;
}

export function includeMenuItemForCountry(m : MenuItem, userCountry?: string, ipCountry? : string) {
    let countryCode = userCountry;
    if(!countryCode){
        countryCode = ipCountry;
    }
    
    if(countryCode) {
        if(m.includeCountries) {
            let countries = m.includeCountries?.split(",");
            let include = countries.find(c => c.trim().toUpperCase() == countryCode?.toUpperCase());
            return include ? true : false;
        } else if(m.excludeCountries) {
            let countries = m.excludeCountries?.split(",");
            let exclude = countries.find(c => c.trim().toUpperCase() == countryCode?.toUpperCase());
            return exclude ? false : true;
        }
    } else if(!userCountry && (m.includeCountries || m.excludeCountries)) {
        return false;
    }
    return true;
}

export class DesktopTopMenu extends React.Component<Props, State> {
    listener : ((e:any) => void);
    constructor(props : Props) {
        super(props);

        this.state = {
            mobile: false,
            // animate: this.props.animate == undefined ? false : this.props.animate
            animate: false,
            scrolled: false,
            smallScreen: false,
            pokerLoaded:false
        }
        this.listener = (e:any) => {
            if(e.detail.pokerLoaded) {
                this.setState({pokerLoaded:true})
            } else {
                this.setState({pokerLoaded:false})
            }
        }
    }
    mounted = false;
    isScrolled = () => {
        let nav = document.getElementById("mainNav");
        if(nav) {
            if(window.pageYOffset > 70) {
                this.setState({ scrolled: true })
            } else {
                this.setState({ scrolled: false })
            }

        };

    }

    componentDidMount(): void {
        this.mounted = true;
        if(!this.props.transparent) {
            window.addEventListener("scroll", this.isScrolled);
        }

        if(this.props.global == undefined) {
            this.props.fetchContent(ContentModelName.GLOBAL, this.props.lng);
        }

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        document.addEventListener("message", this.listener);

        // Should probably have another system here
        window.addEventListener("resize", this.resize);
        this.resize("start");

        if(this.props.animate != undefined) {
            setTimeout(() => {
                this.setState({animate: true});
            }, this.props.delay)

        }
    }
    componentDidUpdate(prevProps: Props): void {
        if(this.props.lng) {
            if(this.props.lng !== prevProps.lng) {
                this.props.fetchContent(ContentModelName.GLOBAL, this.props.lng);
            }
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener("message", this.listener);
        this.mounted = false;
        if(!this.props.transparent) {
            window.removeEventListener("scroll", this.isScrolled);
        }

        window.removeEventListener("resize", this.resize);
    }

    resize = (value: any): any => {
        if(window.innerWidth <= 1200 && window.innerWidth > 768) {
            this.setState({smallScreen: true, mobile: false})
        } else if(window.innerWidth <= 768) {
            this.setState({mobile: true})
        } else {
            this.setState({mobile: false, smallScreen: false})
        }
    };
    toKey(m : MenuItem) {
        let key = ""+m.type;
        if(m.name) {
            key +=m.name;
        }
        return key;
    }

    showSportsbook (show:boolean) {
        if(this.props.toggleShowSportsbook && this.props.toggleShowPoker) {
            this.props.toggleShowSportsbook(show);
            this.props.toggleShowPoker(show);
        }

    }

    iconIsIncluded(icon: string | undefined): boolean{
        if(icon == undefined){
            return false
        } else {
            return Object.values(jsondata).some(key => key.includes(icon))
        }
    }

    render() {
        let menu = getContainer().getSettingsService().getMenu();
        if(!menu || !menu.items) {
            return false;
        }
        let global = this.props.global;

        let items = menu.items.filter(m => m.includeInDesktopMenu).filter(m => includeMenuItemForCountry(m, this.props.userCountry, this.props.ipCountry)).map((m :MenuItem ) => mapMenuItemData(m, this.props.lng, this.props.history.location.pathname, this.props.selectedPage));

        return (
            <Switch>
                <Route exact path="/app"></Route>
                {this.props.pokerLoadingComplete && <Route exact path="/poker/play"></Route>}
                <Route exact path="/poker/desktop"></Route>
                <Route exact path={"/blocked/:country"}></Route>
                <Route path={"/"}>
                    <nav id="mainNav" className={"main-menu-container header " + (this.state.scrolled ? "scrolled" : "") + (this.props.isLandingPage ? " landing-page" : "")}>
                        <div className={"navbar-nav"}>
                            <div className={"desktop-top-menu-nav"}>
                               {this.props.position !== MenuPosition.FIXED && <HamburgerIcon onClick={()=> this.props.showSideMenu && this.props.showSideMenu(true)}/> }
                                
                                {
                                    items.map((m : MenuItemData)=> {

                                        if(m.external) {
                                            return (
                                                <BrandA key={m.name} href={m.url} className={`nav-link ${this.props.position == MenuPosition.FIXED ? "nav-link-icon" : ""} `} target={m.target}>
                                                    {m.text}
                                                    {this.props.position == MenuPosition.FIXED && this.iconIsIncluded(m?.icon?.className) && <i className={"" + m?.icon?.className}></i>}
                                                </BrandA>
                                            )
                                        }
                                        return (
                                            <NavLink key={m.name} exact={true} activeClassName={"active"} to={m.url}
                                                    href={m.text} className={`nav-link ${this.props.position == MenuPosition.FIXED ? "nav-link-icon" : ""} `}
                                                    isActive={(match, location) => isCasinoMenuItemActive(match, location, m)}>
                                                {this.props.position == MenuPosition.FIXED && this.iconIsIncluded(m?.icon?.className) && <i className={"" + m?.icon?.className}></i>}
                                                {m.text}
                                      
                                            </NavLink>
                                        )
                                    })
                                }
                            </div>
                            {this.props.settings?.menu?.settings?.enableLogoTopMenu && global && global.logo && (
                                <div className={"desktop-logo-container"}>
                                    <NavLink onClick={() => this.showSportsbook(false)} className={"linkCss"} exact={true} to="/">
                                        {global && <BrandLogo global={global}/>}
                                    </NavLink>
                                </div>
                            )
                            }
                            <div className={"desktop-user-panel"}>
                                {!this.props.loggedIn && (
                                    <div className="lngAndButtonWrap">
                                        <LanguageMenu scrolled={this.state.scrolled} inNavMenu={true}/>
                                        <button className={"btn btn-secondary desktop-login small fixed-menu-btn topmenu"} onClick={() => {setModalPath({path: {type: PATH.LOGIN, modal: PATH.MODAL_TYPE}, history: this.props.history, options: this.props.userModal})}}>{t("account.login")}</button>
                                        <button className={"btn btn-cta register-link small fixed-menu-btn topmenu"} onClick={() => {setModalPath({path: {type: PATH.REGISTRATION, modal: PATH.MODAL_TYPE}, history: this.props.history, options: this.props.userModal})}}>{t("account.createAccount")}</button>
                                    </div>
                                )}
                                {this.props.loggedIn && (
                                    <Loggedin/>
                                )}
                            </div>
                        </div>
                    </nav>
                </Route>
            </Switch>



        )
    }
}
export const HamburgerIcon = ( props : { onClick? : () => void}) => (
    <button className={"hamburger-bars"} onClick={()=> props.onClick && props.onClick()} aria-label="Open menu">
        <span className={"material-icons"}>menu</span>
    </button>
)

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        showLogin : ()=> dispatch(showLogin(true)),
        showUserNavigation : (show : boolean) => dispatch(toggleShowUserNavigation(show)),
        fetchSettings: () => dispatch(fetchSettings() as any),
        login: (req:ManualLoginRequest) => dispatch(login(req)as any),
        toggleShowSportsbook: (show:boolean) => dispatch(toggleShowSportsbook(show)),
        toggleShowPoker: (show:boolean) => dispatch(toggleShowPoker(show)),
        showSideMenu : (show : boolean) => dispatch(showSideMenu(show))
    }
);
let mapStateToProps = (app : AppState)=> {
    return {
        settings: app.settings.settings,
        userModal: app.user.modal,
        loggedIn : app.user.user && app.user.user.loggedIn,
        balances : app.user.balances,
        global: app.contentful.global,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        popupAppInstall: app.contentful.popupAppInstall,
        appMode : app.user.appMode,
        sportsbookVisible : app.navigation.sportsbookVisible,
        pokerVisible : app.navigation.pokerVisible,
        selectedPage : getSelectedPage(app),
        isLandingPage : app.navigation && app.navigation.isLandingPage,
        pokerLoadingComplete : app.navigation.pokerLoadingComplete,
        userCountry : app.user.user?.country,
        ipCountry : app.settings.country,
        isSidemenuExpanded: app.navigation.isSideMenuExpanded,
        position: app.navigation.sideMenuPosition
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter<Props,any>(DesktopTopMenu));
